import { Link } from "react-router-dom";
import { ReadOnlyMode } from "components/AnalysisRenderMode";
import { Spinner } from "components/Spinner";
import { useIsFetchingModelResults } from "containers/hooks";
import "./Breadcrumb.css";

export default function Breadcrumb({ breadcrumb = [], icon, supplementaryInfo, hideDashboard }) {
    return (
        <div className="PageHead u-print-none">
            <div className="Container u-flexSplit" style={{ minHeight: "auto" }}>
                <ul className="breadcrumb">
                    {!hideDashboard && (
                        <li>
                            <Link to="/" className="IconLink--home">
                                Dashboard
                            </Link>
                        </li>
                    )}
                    {breadcrumb.map((b) => {
                        const { name = "unknown" } = b;
                        const id = name.replace(" ", "_").toLowerCase();
                        return (
                            <li key={b.name}>
                                {b.to && (
                                    <Link to={b.to} id={id}>
                                        {b.name}
                                    </Link>
                                )}
                                {!b.to && <>
                                    <span id={id}>{b.name}</span>
                                    {icon
                                        ? <>
                                            <i className={`icon ${icon}`} />
                                        </>
                                        : <>
                                            <ReadOnlyMode>
                                                <i className="icon icon-lock" />
                                            </ReadOnlyMode>
                                        </>}
                                </>}
                            </li>
                        )
                    })}
                </ul>
                {supplementaryInfo}
                <ModelResultsFetchingToast />
            </div>
        </div>
    )
}

function ModelResultsFetchingToast() {
    const isFetchingModelResults = useIsFetchingModelResults();

    if (isFetchingModelResults) {
        return (
            <div className="u-textWarning u-textBold">
                <span>Refreshing results... </span>
                <Spinner tiny dark />
            </div>
        )
    } else {
        return null;
    }
}
